import React, { createContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { STORAGE_KEYS } from '../Utils/constants';

// Create AuthContext
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // Initialize user state
  const [token, setToken] = useState(null);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true); 

  // Function to handle login
  const login = (token, userInfo) => {
    try {
      setUser(userInfo); // Set user information directly
      setToken(token); // Set the token state
      
      localStorage.setItem(STORAGE_KEYS.USER_INFO, JSON.stringify(userInfo)); // Store user info in localStorage
      navigate('/dashboard'); // Redirect to dashboard after login
    } catch (error) {
      console.error('Error during login:', error);
    }
  };

  // Function to handle logout
  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem(STORAGE_KEYS.TOKEN); // Remove token from localStorage
    localStorage.removeItem(STORAGE_KEYS.USER_INFO); // Remove user info from localStorage
    navigate('/login'); // Redirect to login page
  };

  // Check if the user is already logged in on component mount (initial load)
  useEffect(() => {
    const savedToken = localStorage.getItem(STORAGE_KEYS.TOKEN);
    const savedUserInfo = localStorage.getItem(STORAGE_KEYS.USER_INFO);
    
    if (savedToken && savedUserInfo) {
      setToken(savedToken);
      setUser(JSON.parse(savedUserInfo)); // Set user from localStorage
    }
    // After checking, loading is complete
    setIsLoading(false);
  }, []);

  if (isLoading) {
    return <div>Loading authentication...</div>; // Replace with a spinner or better UI
  }


  return (
    <AuthContext.Provider value={{ user, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
